<template>
  <div class="PressDetail">
    <div class="title setWidth">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item class="breadcrumbItem" :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item class="breadcrumbItem" :to="{ path: '/newsCenter' }">新闻中心</el-breadcrumb-item>
          <el-breadcrumb-item class="breadcrumbItem">当前页面</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="text">
        {{newsItemShow.Title}}
    </div>
    <div class="perssTime ">
      <el-divider><span>{{newsItemShow.AddTime|timeFormat()}}</span></el-divider>
        <!-- <p></p>
        <span>{{newsItemShow.AddTime|timeFormat()}}</span>
        <p></p> -->
    </div>
    <div class="newsItemShow">
        <div class="newsItemShowTop" v-if="newsItemShow.ArticleType === 1">
            <!-- <video  src="http://vfx.mtime.cn/Video/2019/02/04/mp4/190204084208765161.mp4" controls ></video> -->

               <video muted="muted"  class="video" :src="newsItemShow.Video" type="video/mp4" poster="false.png" autoplay="autoplay" controls="controls" loop="-1">
                      <p>你的浏览器不支持video标签.</p>
               </video>
        </div>
        <div  v-else v-html="newsItemShow.Content"></div>
       <!-- <p>{{newsItemShow.Content}}</p> -->
    </div>

  </div>
</template>

<script>
import { getArticleApiShow } from '@/api/news'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      newsItemShow: {} // 新闻详情
    }
  },
  filters: {
    timeFormat
  },
  mounted () {
    this.getArticleApiShow({ id: this.$route.params.id })
  },
  methods: {
    backCenter () {
      this.$router.back()
    },
    // 获取新闻详情
    async getArticleApiShow (data) {
      const res = await getArticleApiShow(data)
      // console.log(res, 'ssss')
      const base = request.defaults.baseURL
      const oldBase = '/Upload/Image/'
      if (res.Msg === '获取成功') {
        this.newsItemShow = res.Data
        this.newsItemShow.Content = this.newsItemShow.Content.replace(/\/Upload\/Image\//g, base + oldBase)
        // this.newsItemShow.Video = request.defaults.baseURL + this.newsItemShow.Video
      }
      // console.log(this.newsItemShow, 'show')
    }
  }

}
</script>

<style  lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.PressDetail{
  width: 100%;
  overflow: hidden;
    // display: flex;
    // justify-content: center;
    // flex-wrap: wrap;
    background: #FFFFFF;
    .setWidth{
        width: 100%;
    }
    // 中间图片
    .newsItemImg{
        width: 1200px*$sun;
        height: 416px*$sun;
    }
    .text{
        // display: flex;
        // justify-content: center;
        // padding: 50px*$sun 0 40px*$sun 0 ;
        width: 1200px*$sun;
        margin: 50px*$sun auto;
        // height: 67px*$sun;
        font-size: 34px*$sun;
        font-weight: 500;
        color: #333333;
        text-align: center;
    }
    .perssTime{
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: center;
        // align-items: center;
        width: 1200px*$sun;
        margin: 50px*$sun auto;
        p{
            width: 488px*$sun;
            height: 1px*$sun;
            background-color: #E6E6E6;
            // border: .0063rem solid #E6E6E6;
        }
        span{
            padding: 0 20px*$sun;
            font-size: 22px*$sun;
            color: #666666;
            font-weight: 500;
        }
    }
    .detail{
        display: flex;
        flex-wrap: wrap;
        padding: 50px*$sun 360px*$sun ;
        height: 383px*$sun;
        font-size: 24px*$sun;
        color: #666666;
        line-height: 50px*$sun;
    }
}
.title{
    display: flex;
    justify-content: space-between;
    margin-top: 50px*$sun;
    width: 100%;
    color: #000;
    margin-top: 50px*$sun;
    .breadcrumb{
        padding: 0 360px*$sun;
        font-size: 24px*$sun;
            .breadcrumbItem{
              font-weight: 500;
            }

    }
}
// 请求富文本
.newsItemShow{
    width: 1200px*$sun;
    min-height: 600px*$sun;
    margin: auto;
    margin-bottom: 50px*$sun;
}
.newsItemShowTop{
    display: flex;
    justify-content: center;
    min-width: 1200px*$sun;
    video {
      width: 900px*$sun;
      height: 600px*$sun;
    }
}
</style>
